/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';

import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import './HtmlText.scss';

function HtmlText({ section_title: sectionTitle, text, testAttrName }) {
  // strip out any variable configured in the portal (e.g. 'This is my {{brandName}}' to 'This is my')
  const stripOutPortalVariables = string => string.replace(/ *\{[^\]]*}/, '');
  const dataTestAttr = testAttrName;

  if (isEmpty(sectionTitle) && isEmpty(text)) {
    return null;
  }

  return (
    <div className="mn_htmlText" data-test={dataTestAttr}>
      { sectionTitle && <SectionTitle title={stripOutPortalVariables(sectionTitle)} useHtmlMarkup />}
      <div
        className="mn_paragraph"
        data-test="html-text-content"
        dangerouslySetInnerHTML={{ __html: stripOutPortalVariables(text) }}
      />
    </div>
  );
}

HtmlText.propTypes = {
  text: PropTypes.string,
  section_title: PropTypes.string,
  namespace: PropTypes.oneOfType([ // eslint-disable-line react/no-unused-prop-types
    PropTypes.string,
    PropTypes.number,
  ]),
  testAttrName: PropTypes.string,
};

HtmlText.defaultProps = {
  namespace: 'default',
  text: '',
  section_title: '',
  testAttrName: 'html-text',
};

export default (props) => <ComponentErrorBoundary><HtmlText {...props} /></ComponentErrorBoundary>;
